export enum CampaignListColumns {
  NAME = 'nameColumn',
  STATE = 'stateColumn',
  OPTIMIZE = 'optimize',
  DELIVERY = 'deliveryColumn',
  CREATIVE = 'creativeColumn',
  SCHEDULE = 'scheduleColumn',
  PROGRESS = 'progressColumn',
  BUDGET = 'budgetColumn',
  PRICE = 'priceColumn',
  Limitation = 'limitationColumn',
  IMPRES = 'impresColumn',
  CLICKS = 'clicksColumn',
  CTR = 'ctrColumn',
  ROAS = 'roasColumn',
  EDITBTNS = 'editBtnsColumn',
}

export const columns = [
  CampaignListColumns.NAME,
  CampaignListColumns.STATE,
  CampaignListColumns.DELIVERY,
  CampaignListColumns.CREATIVE,
  CampaignListColumns.SCHEDULE,
  CampaignListColumns.PROGRESS,
  CampaignListColumns.BUDGET,
  CampaignListColumns.PRICE,
  CampaignListColumns.Limitation,
  CampaignListColumns.IMPRES,
  CampaignListColumns.CLICKS,
  CampaignListColumns.CTR,
  CampaignListColumns.ROAS,
  CampaignListColumns.EDITBTNS,
];
